// @ts-nocheck

import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import AppContainer from './components/App/AppContainer';
import type { CustomRouterHistory } from './createHistory';
import RouterListener from './RouterListener';
import WinabetLibHandler from './winabet-lib/handlers/WinabetLibHandler';
import type { LibraryInputs } from './winabet-lib/types';

type RootProps = {
  store: unknown;
  history: CustomRouterHistory;
  libraryInputs?: LibraryInputs;
  className?: string;
};

const Root = ({ store, history, libraryInputs = {}, className = '' }: RootProps) => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <RouterListener>
          <WinabetLibHandler {...libraryInputs}>
            <AppContainer className={className} />
          </WinabetLibHandler>
        </RouterListener>
      </Router>
    </Provider>
  );
};

export default Root;
